export default __webpack_public_path__ + "../img/21593da08346f82e133fa732d0907209.png";